import { Input } from "antd";
import { useDebounce } from "../../../hooks/useDebounce";

export const DataTableSearch = (props) => {
  const onChange = useDebounce((e) => props?.onChange(e));

  return (
    <Input.Search
      {...props}
      allowClear
      placeholder="Search"
      onChange={onChange}
    />
  );
};
